/** Generate a URL at runtime using current domain and the provided path. */
export function GenerateRunTimeUrl(subDomain: string): string {
    return window.location.origin + '/' + subDomain;
}